import { replaceNbsp } from "../../../../utils";

export default function QuoteRenderer({
  data,
  className,
}: {
  data: {
    text?: string;
    author?: string;
    role?: string;
    image?: {
      upload_id: string;
      url: string;
    };
  };
  className?: string;
}) {
  try {
    const { text, author, role, image } = data;
    return (
      <article className="widget blockquote">
        <div className="widget__body blockquote__body">
          <blockquote>
            {text && <p className="blockquote__text">{replaceNbsp(text)}</p>}
          </blockquote>
          <figure>
            {image && (
              // eslint-disable-next-line @next/next/no-img-element
              <img
                src={image.url}
                className="blockquote__pic"
                alt={author}
                width={64}
                height={64}
              />
            )}
            <figcaption className="blockquote__figcaption">
              {author && (
                <p className="blockquote__figcaption-text">{author}</p>
              )}
              {role && <p className="blockquote__figcaption-text">{role}</p>}
            </figcaption>
          </figure>
        </div>
      </article>
    );
  } catch (error) {
    console.info(`Не удалось отобразить виджет Quote: ${error}`);
    return <></>;
  }
}
